import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_URL } from "../../constant";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import PopOverBox from "../../component/PopOverBox";
import { IoReorderThreeOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import PaginationBar from "../../component/PaginationBar";
import { useSelector } from "react-redux";

function EmployeeManagement() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.employeeManagement === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState([]);
  const [reload, setReload] = useState(false);

  // fetch member details
  async function getEmployees() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/all/employees/${page}?search=${search}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTotalPage(res.data?.data?.totalPages);
      setEmployeeData(res.data?.data?.data);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Member fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // popover options
  const popOverArray = (userId) => {
    return [
      <Link to={`/admin/employee/hr/documents/management/${userId}`}>
        <section className="w-[15rem] p-2 hover:bg-slate-200/40">
          Document Management
        </section>
      </Link>,
      <Link to={`/admin/employee/edit/details/${userId}`}>
        <section className="w-[15rem] p-2 hover:bg-slate-200/40">
          Update Employee
        </section>
      </Link>,
    ];
  };

  useEffect(() => {
    getEmployees();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Employee Management
          </h1>
          <div className="mt-5 w-full">
            <div className="w-full flex justify-end gap-3">
              <TextField
                label="Search"
                size="small"
                onChange={(eve) => setSearch(eve?.target?.value)}
              />
              <ButtonCompo
                variant={"contained"}
                onClick={() => setReload((prev) => !prev)}
              >
                Search
              </ButtonCompo>
            </div>
            <div className="w-full mt-5">
              <Table>
                <TableHead>
                  <TableRow className="bg-blue-500">
                    <TableCell className="!text-center !text-white !font-semibold">
                      SL No
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Employee ID
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Date of Onboarding
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Name
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Email
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Phone Number
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Role
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Designation
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      CTC
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      Update
                    </TableCell>
                    <TableCell className="!text-center !text-white !font-semibold">
                      More
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="border">
                  {employeeData?.map((e, i) => (
                    <TableRow>
                      <TableCell className="!text-center !font-medium">
                        {i + 1}
                      </TableCell>
                      <TableCell className="!text-center !font-medium !text-blue-600">
                        <span className="bg-blue-200/40 px-3 py-2 rounded-full font-medium text-[13px]">
                          {e?.employeeId}
                        </span>
                      </TableCell>
                      <TableCell className="!text-center">
                        {new Date(e?.onBoardingDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.fullName}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.profEmail}
                      </TableCell>
                      <TableCell className="!text-center">
                        {e?.phoneNumber}
                      </TableCell>
                      <TableCell className="!text-center">{e?.role}</TableCell>
                      <TableCell className="!text-center">
                        {e?.designation}
                      </TableCell>
                      <TableCell className="!text-center">
                        <span className="bg-green-200/40 text-green-700 px-3 py-2 rounded-full font-medium text-[13px]">
                          ₹{e?.ctc}
                        </span>
                      </TableCell>
                      <TableCell className="!text-center">
                        <ButtonCompo href={`/admin/employee/single/${e?._id}`}>
                          View
                        </ButtonCompo>
                      </TableCell>
                      <TableCell className="!text-center">
                        <PopOverBox
                          trigger={
                            <ButtonCompo className="">
                              <IoReorderThreeOutline size={"25px"} />
                            </ButtonCompo>
                          }
                          dataArray={popOverArray(e?._id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <PaginationBar
                attendancePage={page}
                setAttendancePage={setPage}
                totalAttendancePage={totalPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeManagement;
